import { clsx } from 'clsx';
import * as React from 'react';

import * as styles from './Column.css';

type TGapSize = 'L' | 'M';
interface IColumnProps {
  gapSize?: TGapSize;
}

export const Column: React.FC<React.PropsWithChildren<IColumnProps>> = ({ children, gapSize = 'L' }) => {
  return (
    <div className={clsx(styles['container'], gapSize === 'L' && styles['gap-l'], gapSize === 'M' && styles['gap-m'])}>
      {children}
    </div>
  );
};

Column.displayName = 'Column';
